import React from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { ToastContainer } from "react-toastify";
import { Navbar, Sidebar, Footer } from "./components";
import AnimatedRoutes from "./components/AnimatedRoutes";
import Analytics from "./components/Analytics";
import CookieConsent from "react-cookie-consent";

const grantAnalyticsConsent = () => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  }
};

const denyAnalyticsConsent = () => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <Analytics />
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Navbar />
        <Sidebar />
        <div className="route-area">
          <AnimatedRoutes />
        </div>
        <Footer />
        <CookieConsent
          location="bottom"
          buttonText="Rozumím a souhlasím"
          declineButtonText="Odmítnout"
          enableDeclineButton
          cookieName="bbs_cookie_consent"
          expires={365}
          onAccept={grantAnalyticsConsent}
          onDecline={denyAnalyticsConsent}
          style={{
            background: "var(--clr-dark-1)",
            color: "var(--clr-cream)",
            fontFamily: "var(--ff-body)",
            fontSize: "0.95rem",
            padding: "1rem 1.5rem",
            boxShadow: "0 -4px 16px rgba(0,0,0,0.2)",
            alignItems: "center",
            zIndex: 9999,
          }}
          contentStyle={{
            flex: "1 1 320px",
            margin: "0.5rem 1rem",
            lineHeight: 1.5,
          }}
          buttonStyle={{
            background: "var(--clr-accent)",
            color: "var(--clr-paper)",
            fontWeight: 600,
            padding: "0.75rem 1.5rem",
            borderRadius: "999px",
            border: "none",
            cursor: "pointer",
            fontSize: "0.9rem",
            fontFamily: "var(--ff-body)",
            margin: "0.5rem 0.5rem",
          }}
          declineButtonStyle={{
            background: "transparent",
            color: "var(--clr-cream)",
            border: "1px solid var(--clr-cream)",
            padding: "0.75rem 1.5rem",
            borderRadius: "999px",
            fontSize: "0.9rem",
            fontFamily: "var(--ff-body)",
            margin: "0.5rem 0.5rem",
            cursor: "pointer",
          }}
        >
          Tento web používá cookies pro zlepšení uživatelského zážitku. Více informací najdete v{" "}
          <Link to="/info" style={{ color: "var(--clr-accent-light)", textDecoration: "underline" }}>
            zásadách ochrany osobních údajů
          </Link>
          .
        </CookieConsent>
      </Router>
    </MotionConfig>
  );
}

export default App;
